import styled from 'styled-components';

export const EndCardsItemsNoHover = styled.div`
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  position: relative;

  header {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;

    .title {
      h1 {
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 5px;
        color: #2e3958;
      }

      &__update {
        width: fit-content;
        font-size: 0.8rem;
        font-weight: 600;
        color: #2e3958;
        padding: 8px;
        background: #ecf1ff;
        border-radius: 6px;
        display: flex;
        align-items: center;
      }
    }
  }

  .react-icons {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 24px;
    color: #c9ced6;
    cursor: pointer;

    &:hover {
      color: #828282;
    }
  }

  section {
    display: flex;
    justify-content: space-around;
    align-items: center;

    article {
      text-align: center;

      h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #2e3958;
      }

      span {
        font-size: 1rem;
        font-weight: 700;
        color: #aeaeae;
      }
    }
  }
`;
const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

const TooltipIcon = styled.div`
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;
const TooltipBox = styled.div`
  visibility: hidden;
  width: 450px;
  background-color: #ffffff;
  color: #333;
  text-align: left;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  position: absolute;
  z-index: 159;
  top: 130%; /* Aparece abaixo do ícone */
  left: 0; /* Alinhado ao início do container */
  opacity: 0;
  transition: opacity 0.3s ease;

  ${TooltipContainer}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;
const TooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 6px;
  color: #1d3557;
`;

const TooltipText = styled.div`
  font-size: 14px;
  color: #444;
  white-space: normal;
`;

export { TooltipBox, TooltipContainer, TooltipIcon, TooltipTitle, TooltipText };
